import { MDBAlert, MDBBtn, MDBIcon } from "mdbreact"
import React from "react"
import { Link } from "react-router-dom"
import { Card, CardBody, Col, Collapse, Container, Form, Input, Label, Media, Row, Table } from "reactstrap"
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import _valid from "../../validations"
import { TIEMPO_MOSTRAR_ERROR } from "../../ayudas/constantes"
import { TAMANIO_IMG_COLUMNAS_LG, TAMANIO_IMG_COLUMNAS_SM, TAMANIO_IMG_COLUMNAS_XS } from "../../ayudas/constantes";
import { obtener_formulario_omitiendo_imagenes_ya_guardadas } from "../../ayudas/funciones"
import Lightbox from 'react-image-lightbox';
import Select from 'react-select';

export default class editarAsignado extends React.Component {

    constructor(props) {
        super(props);

        this.apiRest = new ApiRest(props);

        this.state = {
            registro: _valid(this.props.location.registro) ? this.props.location.registro : {
                id: null,
                idArticulo: null,
                idColaborador: null,
                idDepartamento: null,
                cantidad: null,
                fecha: null
            },
            colapsar: true,
            camposRequeridos: [],
            departamentoAreas: [],
            colaboradores: [],
            articuloLista: []
        };
        this.almacenarRegistro = this.almacenarRegistro.bind(this);
        this.datosRegistroValidos = this.datosRegistroValidos.bind(this);
        this.actualizarDatos = this.actualizarDatos.bind(this);
    }

    componentDidMount() {
        this.obtenerDepartamentos();
        this.obtenerArticulos();
        const{
            registro
        } = this.state
        if (_valid(registro.idDepartamento)) {
            this.obtenerColaborador(registro.idDepartamento);
        }
    }

    colapsar() {
        this.setState(estadoAnterior => ({ colapsar: !estadoAnterior.colapsar }));
    }

    actualizarDatos = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            registro: { ...estadoAnterior.registro, [name]: value }
        }));
    }

    almacenarRegistro = async () => {
        const {
            registro
        } = this.state
        
        let idArticulo = registro.idArticulo;
        let idColaborador = registro.idColaborador;
        let idDepartamento = registro.idDepartamento;
        let fecha = registro.fecha;
        let cantidad = registro.cantidad;
        let estado = registro.estado;
        let id = registro.id;

        const data = {
            idArticulo,
            idColaborador,
            idDepartamento,
            fecha,
            cantidad,
            estado
        }
        
        if (this.datosRegistroValidos(data)) {
            this.guardarData(id,data);
        } else {
            
        }
    }

    guardarData = async (id, registro) => {
        this.apiRest.put('/actualizarAsignados/'+id,registro).then(resultado => {
            if (resultado.exitoso) {
                toastr.success('Datos almacenados exitosamente!');
                this.saveHistory(resultado.data)
                this.setState({registro: resultado.data});
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    saveHistory = (data) => {
        if (_valid(data)) {
            let registro = this.historial(data);
            this.apiRest.post('/asignarHistorial',registro).then(resultado => {
                if (resultado.exitoso) {
                    
                }
            });
        }
    }

    historial = (data) => {
        let user = this.apiRest.getLS('du').colaborador.id
        if (_valid(data)) {
            let asignado = data.id
            let articulo = data.idArticulo
            let colaborador_que_asigna = user
            let colaborador_que_recibe = data.idColaborador
            let comentario = 'Se actualizo el registro: '+data.id+''
            let estado = 2
            const registro = {
                asignado,
                articulo,
                colaborador_que_asigna,
                colaborador_que_recibe,
                comentario,
                estado
            }
            return registro
        }
        return null
    }

    datosRegistroValidos(data) {
        const {
            articuloLista
        } = this.state
        let contador = 0;
        const { camposRequeridos } = this.state;
        if (!_valid(data.cantidad)) {
            camposRequeridos.push("cantidad");
        } else {
            let id = parseInt(data.idArticulo);
            let element = articuloLista.find(function(element) {
                if(element.id == id){
                    return element
                }
            });
            if(data.cantidad <= element.cantidad){
                contador += 1;
            }else{
                camposRequeridos.push("La cantidad asignada excede de la capacidad almacenada, campo ");
            }
        }
        if (!_valid(data.idDepartamento)) {
            camposRequeridos.push("departamento");
        } else {
            contador += 1;
        }
        if (!_valid(data.idColaborador)) {
            camposRequeridos.push("colaborador");
        } else {
            contador += 1;
        }
        if (!_valid(data.fecha)) {
            camposRequeridos.push("fecha asignado");
        } else {
            contador += 1;
        }
        this.setState({ camposRequeridos: camposRequeridos });
        setTimeout(() => this.setState({ camposRequeridos: [] }), TIEMPO_MOSTRAR_ERROR);

        if (contador === 4) {
            return true
        } else {
            return false;
        }
    }

    //obtener area departamento
    obtenerDepartamentos() {
        this.apiRest.get('/departamentoArea').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ departamentoAreas: resultado.data });
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    //obtener articulos listado
    obtenerArticulos() {
        this.apiRest.get('/articulo').then(respuesta => {
            if (respuesta.exitoso) {
                this.setState({ articuloLista: respuesta.data });
            }
        });
    }

    obtenerColaborador(id) {
        this.apiRest.get('/listaColaborador/' + id).then(resultado => {
            if (resultado.exitoso) {
                if (_valid(resultado.data)) {
                    this.setState({ colaboradores: resultado.data });
                } else {
                    this.setState({ colaboradores: [] });
                    toastr.error('No hay colaboradores asignados');
                }
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    //formato a valores de area
    formatoSelect = valores => valores.data.map(i => ({ value: i.id, label: i.nombre }));

    //set nombre area
    setArea = asignado => {
        this.setState({ solicitar_area: asignado });
    }

    cambiosSolicitarA = ({ target: { name, value } }) => {
        const asignado = {
            name,
            value
        }

        this.setState(estadoAnterior => ({
            registro: { ...estadoAnterior.datos, [name]: value }
        }));

        this.getColaborador(asignado);
    }

    cambiosSolicitar = asignado => {
        this.setState({ colaborador: asignado });
    }

    getColaborador(data) {
        this.apiRest.get('/listaColaborador/' + data.value).then(resultado => {
            if (resultado.exitoso) {
                if (_valid(resultado.data)) {
                    this.setState({ colaboradores: resultado.data });
                } else {
                    this.setState({ colaboradores: [] });
                    toastr.error('No hay colaboradores asignados');
                }
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    formatoSelectColaborador = valores => valores.data.map(i => ({ value: i.id, label: i.nombres + " " + i.apellidos }));

    render() {
        const {
            registro,
            colapsar,
            camposRequeridos,
            departamentoAreas,
            colaboradores,
            articuloLista
        } = this.state;

        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Datos" breadcrumbItem="Articulo" />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <Link onClick={() => this.colapsar()} className="text-dark" to="#">
                                            <div className="p-4">
                                                <Media className="d-flex align-items-center">
                                                    <div className="me-3">
                                                        <i className="uil uil-receipt text-primary h2"></i>
                                                    </div>
                                                    <div className="flex-1 overflow-hidden">
                                                        <h5 className="font-size-16 mb-1">Asignar Articulo</h5>
                                                        <p className="text-muted text-truncate mb-0">Por favor, proporciona los datos.</p>
                                                    </div>
                                                    <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                </Media>
                                            </div>
                                        </Link>
                                        <Collapse isOpen={colapsar}>
                                            <div className="p-4 border-top">
                                                <Form>
                                                    <div>
                                                        <Row>
                                                            <Col lg={12}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="idArticulo" className="form-label">
                                                                        Articulo
                                                                    </Label>
                                                                    <select
                                                                        value={registro.idArticulo}
                                                                        onChange={this.actualizarDatos}
                                                                        name="idArticulo"
                                                                        className="form-control"
                                                                    >
                                                                        <option value="0">Seleccionar</option>
                                                                        {articuloLista.map(item => <option key={item.id} value={item.id}>{"serie: " + item.serie + ",  articulo: " + item.nombre}</option>)}
                                                                    </select>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="tipo" className="form-label">
                                                                        Estado
                                                                    </Label>
                                                                    <select
                                                                        value={registro.estado}
                                                                        onChange={this.actualizarDatos}
                                                                        name="estado"
                                                                        className="form-control"
                                                                    >
                                                                        <option value="0">No Asignado</option>
                                                                        <option value="1">Proceso de Ensamble</option>
                                                                        <option value="2">Proceso de Configurado</option>
                                                                        <option value="3">Almacenado</option>
                                                                        <option value="4">Entregado</option>
                                                                        <option value="5">Rechazado</option>
                                                                        <option value="6">Aceptado</option>
                                                                        <option value="7">Parcialmente Aceptado</option>
                                                                        <option value="8">No aceptado</option>
                                                                        <option value="9">En Mantenimiento</option>
                                                                        <option value="10">De baja</option>
                                                                    </select>
                                                                </div>
                                                            </Col>
                                                            <Col log={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="cantidad" className="form-label">
                                                                        Cantidad:
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.cantidad}
                                                                        onChange={this.actualizarDatos}
                                                                        name="cantidad"
                                                                        min="0"
                                                                        type="number"
                                                                        className="form-control"
                                                                        placeholder="Ingresa la cantidad"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="fecha" className="form-label">
                                                                        Fecha de Asignacion
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.fecha}
                                                                        onChange={this.actualizarDatos}
                                                                        name="fecha"
                                                                        type="date"
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg={6}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="idDepartamento" className="form-label">
                                                                        ( Departamento / &Aacute;rea)
                                                                    </Label>
                                                                    <select
                                                                        value={registro.idDepartamento}
                                                                        onChange={this.cambiosSolicitarA}
                                                                        name="idDepartamento"
                                                                        className="form-control"
                                                                    >
                                                                        <option value="0">Seleccionar</option>
                                                                        {departamentoAreas.map(item => <option key={item.id} value={item.id}>{item.nombre}</option>)}
                                                                    </select>
                                                                </div>
                                                            </Col>
                                                            <Col lg={6}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="idColaborador" className="form-label">
                                                                        Colaborador
                                                                    </Label>
                                                                    <select
                                                                        value={registro.idColaborador}
                                                                        onChange={this.actualizarDatos}
                                                                        name="idColaborador"
                                                                        className="form-control"
                                                                    >
                                                                        <option value="0">Seleccionar</option>
                                                                        {colaboradores.map(item => <option key={item.id} value={item.id}>{item.nombres + " " + item.apellidos}</option>)}
                                                                    </select>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                    &nbsp;
                                                    <Row>
                                                        {_valid(camposRequeridos) && camposRequeridos.map((campo, index) => <MDBAlert key={index} color="danger"><strong>{campo}</strong> es requerido.</MDBAlert>)}
                                                    </Row>
                                                </Form>
                                            </div>
                                            <Row>
                                                <Col lg={12} className="text-end">
                                                    <MDBBtn className="waves-effect" color="danger" onClick={() => { this.props.history.replace('/listaAsignado') }}>
                                                        <MDBIcon icon="fas fa-arrow-left" />{' '}
                                                        Regresar
                                                    </MDBBtn>
                                                    {' '}
                                                    <MDBBtn className="waves-effect" color="success" onClick={() => this.almacenarRegistro()}>
                                                        <MDBIcon icon="fas fa-user-check" /> {' '}
                                                        Guardar
                                                    </MDBBtn>
                                                </Col>
                                            </Row>
                                        </Collapse>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}